module.exports = __webpack_public_path__ + "img/yellow_lock.f19472d6.gif";